export default __webpack_public_path__ + "static/media/eHealthcareAward22.71d9adfd.png";